import styled from 'styled-components';

import { StyledControlBarButton } from '../control-bar-button.styles';

export const StyledShowSettingsDropdownButton = styled(StyledControlBarButton)`
  &:hover {
    & path {
      stroke: ${({ theme }) =>
        theme.themeColors.controlBar.rightPanel.icons.settingsIcon
          .colorOnHover};
    }
  }

  &:active {
    & path {
      stroke: ${({ theme }) =>
        theme.themeColors.controlBar.rightPanel.icons.settingsIcon
          .colorOnActive};
    }
  }
`;
